<template>
  <div class="info">
    <div class="info-main">
      <div class="main-title">{{ infoResult.title }}</div>
      <div class="tab-wrap">
        <div class="main-tab">{{ infoResult.initiator }}</div>
        <div class="main-tablink">{{ infoResult.link }}</div>
      </div>
      <div class="main-list">负责专员<span>{{infoResult.staff}}</span></div>
      <div class="main-list">企业名称<span>{{infoResult.part}}</span></div>
      <div class="main-list">联系对象<span>{{infoResult.person}}</span></div>
      <div class="main-list">联系电话<span>{{infoResult.phone}}</span></div>
      <div class="main-list">预约时间<span>{{infoResult.time}}</span></div>
    </div>
    <div class="info-textwrap">
      <div class="info-title">描述</div>
      <div class="info-text">{{infoResult.text || '-'}}</div>
    </div>
    <div class="info-visit" v-if="infoResult.status==7 || infoResult.status==8">
      <div class="info-textwrap">
        <div class="info-title">走访记录</div>
        <div class="info-text">{{infoResult.visit || '暂无'}}</div>
      </div>
      <div class="info-imgs" v-if="infoResult.imgs.length>0">
        <van-image v-for="(item, i) in infoResult.imgs" :key="i" :src="item" fit="cover" @click="imgTap(i)" />
      </div>
    </div>
    <div class="info-visit"  v-if="infoResult.status==8">
      <div class="info-textwrap">
        <div class="info-title">企业评分</div>
        <van-rate
          v-model="infoResult.rateValue"
          :size="14"
          color="#3366FF"
          void-icon="star"
          void-color="#eee"
          readonly
        />
      </div>
      <div class="info-textwrap info-rate">
        <div class="info-title">企业评价</div>
        <div class="info-text">{{infoResult.rateMessage}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'

export default {
  props: ['infoResult'],
  methods: {
    imgTap(i) {
      ImagePreview({
        images: this.infoResult.imgs,
        startPosition: i
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.info-main {
  background:#fff;
  padding:15px;
  margin-top:10px;
  .main-title {
    font-size: 16px;
    color: #303133;
    font-weight: bold;
  }
  .tab-wrap {
    display: flex;
    align-content: center;
    margin: 16px 0 16px;
    .main-tab {
      font-size: 10px;
      color: #fff;
      background: #0084ff;
      border-radius: 4px;
      padding: 2px 4px;
    }
    .main-tablink {
      font-size: 10px;
      color: #0084ff;
      background: #e5f4ff;
      border-radius: 4px;
      padding: 2px 4px;
      margin-left: 10px;
    }
  }
  .main-list{
    font-size:14px;
    color:#999;
    margin-top:8px;
    span{
      color:#333;
      margin-left:10px;
    }
  }
}
.info-visit{
  background:#fff;
}
.info-textwrap{
  background:#fff;
  padding:15px;
  margin-top:10px;
  display:flex;
  align-items: center;
  overflow: hidden;
  .info-title{
    white-space: nowrap;
    font-size:14px;
    color:#999;
    width:60px;
  }
  .info-text{
    flex:1;
    font-size:14px;
    color:#333;
    line-height:20px;
    word-wrap:break-word;
    overflow: hidden;
  }
}
.info-rate{
  margin:0;
  padding-top:0;
}
.info-imgs{
  padding:0 15px 15px;
  display:grid;
  grid-template-columns: repeat(5,1fr);
  grid-gap: 15px;
  .van-image{
    width:100%;
    height:50px;
    border-radius:4px;
    overflow: hidden;

  }
}
</style>
